import {Md5} from 'ts-md5';

import {FileGroupTypes} from '../entities/file';

/**
 * @ignore
 * @internal
 * */
export class Helper {
  public static uniqueIds: string[] = [];

  static fileExt(type: (FileGroupTypes)[] = ['video', 'image', 'doc']): string[] {

    const map = {
      video: [
        'mp4', 'avi', 'wmv', 'mov', '3gp', 'flv', 'mpeg', 'webm'
      ],
      image: [
        'jpeg', 'jpg', 'gif', 'png'
      ],
      doc: [
        'pdf', 'docx', 'doc', 'rtf', 'xls', 'xlsx'
      ]
    };

    let res: string[] = [];

    type.forEach((t) => {
      res = [...res, ...(map as never)[t]];
    });

    return res;
  }

  static validURL(str: string) {
    const pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
      '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
      '(\\:\\d+)?(\\/[-a-zа-я\\d%_.,~+\\s\\(\\)]*)*' + // port and path
      '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
      '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator
    return !!pattern.test(str);
  }

  static validBlob(str: string) {
    const pattern = new RegExp('^blob', 'i'); // fragment locator
    return !!pattern.test(str);
  }

  static randomString(length: number): string {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  static md5(string: string): string {
    const md5 = new Md5();
    md5.appendStr(string);
    return md5.end().toString();
  }

  static getRandomClientId(salt: string): string {
    const random = Helper.md5(salt + Helper.randomString(25).toString() + new Date().getTime().toString());

    if (Helper.uniqueIds.includes(random)) {
      return Helper.getRandomClientId(salt);
    } else {
      Helper.uniqueIds.push(random);
      return random;
    }
  }

  static convertFiles(items: any[]): any[] {
    const newItems: any[] = [];

    // @todo rework to map
    items.forEach((item) => {
      newItems.push(this.convertFile(item));
    })

    return newItems;
  }

  static convertFile(item: any): any {
    if (item.lastModified) {
      return {
        __entity: 'WebApiFile',
        binary: item,
        lastModified: item.lastModified,
        lastModifiedDate: item.lastModifiedDate,
        name: item.name,
        size: item.size,
        type: item.type,
        webkitRelativePath: item.webkitRelativePath,
      }
    } else {
      return {...{__entity: 'File'}, ...item}
    }
  }

  static getFormattedPhone(phone: string, code = '+7'): string | null {
    if (phone) {
      const regex = /^(\+\d|8)(\d{3})(\d{3})(\d{2})(\d{2})$/;
      const m = regex.exec(phone);
      if (m !== null && m.length === 6) {
        return `${code} ${m[2]} ${m[3]} ${m[4]} ${m[5]}`;
      } else {
        return phone;
      }
    }

    return null;
  }

  static diffBetweenDatesMinutes(date1: Date, date2: Date) {
    const diff = Math.abs(date1.getTime() - date2.getTime());
    return Math.floor((diff / 1000) / 60);
  }
}
